/**
 * 予約レコード
 */
class ReservationRecord {
    /**
     * constructor
     *
     * @param {string} code
     * @param {string} room
     * @param {string} date
     * @param {string} morning
     * @param {string} afternoon
     * @param {string} night
     */
    constructor(code, room, date, morning, afternoon, night) {
        this.code = code;
        this.room = room;
        this.date = date;
        this.morning = morning;
        this.afternoon = afternoon;
        this.night = night;
    }

    /**
     * 配列からの新規作成
     *
     * @param {Array} record
     * @return {ReservationRecord}
     */
    static create(record) {
        return new ReservationRecord(record[0], record[1], record[2], record[3], record[4], record[5]);
    }
}

export default ReservationRecord;
